import { CheckoutAsyncThunk, portalAction, PortalThunk } from '../types'
import { MPANPaymentSourceCaptureResponse, PaymentSourceCaptureMPANFlowRequest, PaymentSourceCaptureRequest, PaymentSourceCaptureResponse } from '../../model'
import { app } from '../../../src/env'

// to be deprecated with captureApplePayPaymentNew replacing this
export const captureApplePayPayment: CheckoutAsyncThunk<PaymentSourceCaptureRequest, PaymentSourceCaptureResponse> = portalAction(
  'applepay/token',
  async (request, thunk) => {
    return await thunk.extra.paymentsSourceCapture().post('/source-capture/v1/payment-sources/apple-pay', request)
  },
  false,
  app.ENABLE_VERBOSE_NON_PORTAL_API_ERRORS === 'true'
)

export const captureApplePayPaymentForMpanFlow: CheckoutAsyncThunk<PaymentSourceCaptureMPANFlowRequest, MPANPaymentSourceCaptureResponse> = portalAction(
  'applepayMpan/token',
  async (request, thunk) => {
    return await thunk.extra.portalApi().post('/portal/consumers/apple-pay-token/capture', request)
  }
)

export const validateMerchant: PortalThunk<ApplePayJS.ApplePayValidateMerchantEvent, { sessionObject: string }> = portalAction(
  'applepay/validateMerchant',
  async (event: ApplePayJS.ApplePayValidateMerchantEvent, thunk) => {
    return await thunk.extra.portalApi().post('/portal/consumers/apple-pay-sessions', { validationUrl: event.validationURL })
  }
)
